module.exports = __webpack_public_path__ + "img/party3.3f7f0a8e.png";